import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faFileLines,
  faGears,
  faEye,
  faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";

const ProcessSectionNew = () => {
  return (
    <section className="ps-section">
      <div className="container">
        <div className="ps-header">
          <p className="ps-eyebrow">Simple & Easy</p>
          <h2 className="ps-title">
            How to order at Grandindigo Digitizing
          </h2>
        </div>

        <div className="ps-grid">

          <div className="ps-card">
            <div className="ps-icon-wrap">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <span className="ps-step-badge">STEP 1</span>
            <h3 className="ps-card-title">Register and Login</h3>
            <p className="ps-card-desc">
              Register your account by clicking Signup option. Enter your details & you'll receive
              your account details via email. Get details of account at email & login into your
              account from login option.
            </p>
          </div>

          <div className="ps-card">
            <div className="ps-icon-wrap">
              <FontAwesomeIcon icon={faFileLines} />
            </div>
            <span className="ps-step-badge">STEP 2</span>
            <h3 className="ps-card-title">Artwork and Instructions</h3>
            <p className="ps-card-desc">
              Upload your artwork. Provide us design details and any additional instructions.
              You can also mention us your order is urgent or not.
            </p>
          </div>

          <div className="ps-card">
            <div className="ps-icon-wrap">
              <FontAwesomeIcon icon={faGears} />
            </div>
            <span className="ps-step-badge">STEP 3</span>
            <h3 className="ps-card-title">Your Order is Under Process</h3>
            <p className="ps-card-desc">
              Wait for 3-24 hours for job done (Depending on Complexity). We need to provide
              3 hours for urgent orders as the processing time.
            </p>
          </div>

          <div className="ps-card">
            <div className="ps-icon-wrap">
              <FontAwesomeIcon icon={faEye} />
            </div>
            <span className="ps-step-badge">STEP 4</span>
            <h3 className="ps-card-title">Review Final Work</h3>
            <p className="ps-card-desc">
              If you want any minor editing you can inform us. Check your order & approve our work.
              We finalize your jobs and give quality assurance as well.
            </p>
          </div>

          <div className="ps-card">
            <div className="ps-icon-wrap">
              <FontAwesomeIcon icon={faFileInvoiceDollar} />
            </div>
            <span className="ps-step-badge">STEP 5</span>
            <h3 className="ps-card-title">Invoice and Payment</h3>
            <p className="ps-card-desc">
              After you satisfy with our work you'll get your order payment invoice via email.
              You can pay us via PayPal, Credit Card or Bank Cheque. Regular clients can pay
              us on weekly, 15 days or monthly basis.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProcessSectionNew;